import { makeUseAuth } from '@wg/hooks/auth';
import { auth } from '../client';

// Bound to this app's AuthCore singleton. Reads/writes the embed's
// localStorage-backed session and exposes the standard wunderguide auth
// state machine: null (hydrating) → 'guest' | 'authenticated' | 'unauthenticated'.
//
// The exported hook MUST be used inside <AuthProvider core={auth}> (mounted
// in App.tsx). When the underlying auth core fires sessionCleared (e.g.
// refresh-token rejected after a deploy invalidates the user), authState
// flips back to 'unauthenticated' and InstanceProvider's guest-bootstrap
// effect re-fires createGuest() — self-healing.
export const useAuth = makeUseAuth(auth);
